var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSugarGliderOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_176900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.592 318C227.463 318 275.997 311.337 275.997 303.117C275.997 294.898 227.463 288.234 167.592 288.234C107.722 288.234 59.1875 294.898 59.1875 303.117C59.1875 311.337 107.722 318 167.592 318Z",
    fill: "#EDB27C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.765 255.31C267.277 254.338 266.606 253.366 265.752 252.576C264.898 251.787 263.922 251.058 262.824 250.511C261.726 249.964 260.506 249.6 259.163 249.357C259.163 249.357 253.185 247.656 241.716 253.67C236.47 256.403 230.735 258.226 224.818 258.59C218.046 259.015 209.506 258.104 200.66 253.245L198.403 251.847L197.549 254.156L196.024 256.282C195.536 256.889 195.109 257.436 194.621 257.983C194.133 258.529 193.584 259.076 192.852 259.744C193.584 260.595 194.316 261.384 195.109 262.174C195.902 262.964 196.695 263.693 197.549 264.483C198.403 265.211 199.318 265.94 200.233 266.669C201.148 267.398 202.124 268.067 203.161 268.735C204.137 269.403 205.235 270.01 206.273 270.618C207.371 271.225 208.469 271.833 209.628 272.379C210.787 272.926 211.946 273.412 213.166 273.898C214.203 274.323 215.301 274.688 216.399 275.052C217.497 275.417 218.595 275.72 219.694 276.024C220.792 276.328 221.951 276.571 223.11 276.814C224.269 277.057 225.428 277.239 226.587 277.421C227.746 277.604 228.905 277.725 230.125 277.847C231.284 277.968 232.504 278.029 233.664 278.09C234.823 278.15 236.043 278.15 237.202 278.15C238.361 278.15 239.52 278.09 240.679 278.029C241.96 277.968 243.241 277.847 244.522 277.664C245.803 277.482 247.024 277.3 248.305 277.057C249.525 276.814 250.745 276.51 251.904 276.206C253.063 275.903 254.161 275.538 255.259 275.113C256.357 274.688 257.394 274.263 258.37 273.777C259.346 273.291 260.261 272.744 261.116 272.197C262.153 271.529 263.129 270.8 263.983 270.01C264.837 269.221 265.569 268.37 266.24 267.52C266.85 266.609 267.399 265.697 267.826 264.725C268.253 263.754 268.497 262.782 268.68 261.749C268.863 260.716 268.863 259.684 268.741 258.59C268.558 257.314 268.253 256.282 267.765 255.31Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.75 252.516C264.896 251.726 263.92 250.997 262.822 250.45C261.724 249.903 260.504 249.539 259.162 249.296C259.162 249.296 253.549 247.717 242.812 253.062C246.168 254.338 250.377 256.768 252.512 260.959C252.756 261.445 252.207 261.931 251.78 261.627L249.279 260.109C249.279 260.109 255.318 265.758 253.122 275.66C253.854 275.417 254.586 275.174 255.257 274.931C256.355 274.506 257.393 274.08 258.369 273.594C259.345 273.108 260.26 272.562 261.114 272.015C262.151 271.347 263.127 270.618 263.981 269.828C264.835 269.038 265.567 268.188 266.238 267.338C266.848 266.426 267.397 265.515 267.824 264.543C268.251 263.571 268.495 262.599 268.678 261.567C268.861 260.534 268.861 259.501 268.739 258.408C268.617 257.314 268.312 256.282 267.763 255.31C267.214 254.277 266.543 253.366 265.75 252.516Z",
    fill: "#332D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.765 255.31C267.277 254.338 266.606 253.366 265.752 252.577C264.959 251.787 264.044 251.119 263.007 250.633C263.129 250.754 263.312 250.876 263.434 250.997C264.227 251.787 264.898 252.759 265.386 253.731C265.874 254.703 266.179 255.796 266.301 256.829C266.423 257.922 266.423 258.955 266.24 259.988C266.118 261.02 265.813 261.992 265.447 262.964C265.081 263.936 264.532 264.847 263.922 265.698C263.312 266.548 262.58 267.399 261.726 268.188C260.872 268.978 259.956 269.707 258.919 270.375C258.065 270.922 257.15 271.469 256.174 271.955C255.198 272.441 254.222 272.866 253.124 273.291C252.087 273.716 250.989 274.081 249.83 274.384C248.671 274.688 247.512 274.992 246.291 275.235C245.071 275.478 243.851 275.66 242.631 275.842C241.411 276.025 240.13 276.085 238.849 276.207C237.69 276.268 236.592 276.328 235.433 276.328C234.274 276.328 233.115 276.328 231.955 276.268C230.796 276.207 229.637 276.146 228.478 276.025C227.319 275.903 226.16 275.782 225.001 275.599C223.842 275.417 222.683 275.235 221.585 274.992C220.487 274.749 219.328 274.506 218.229 274.202C217.131 273.898 216.033 273.595 214.935 273.23C213.837 272.866 212.8 272.501 211.763 272.076C210.604 271.59 209.445 271.104 208.286 270.557C207.188 270.011 206.09 269.403 204.991 268.796C203.954 268.188 202.917 267.52 201.941 266.913C200.965 266.245 199.989 265.576 199.074 264.847C198.159 264.118 197.305 263.389 196.451 262.661C195.597 261.932 194.804 261.142 194.011 260.352C193.706 260.048 193.462 259.745 193.157 259.441C193.035 259.562 192.974 259.623 192.852 259.745C193.584 260.595 194.316 261.385 195.109 262.175C195.902 262.964 196.695 263.693 197.549 264.483C198.403 265.212 199.318 265.941 200.233 266.67C201.148 267.399 202.124 268.067 203.161 268.735C204.137 269.403 205.235 270.011 206.273 270.618C207.371 271.226 208.469 271.833 209.628 272.38C210.787 272.927 211.946 273.413 213.166 273.898C214.203 274.324 215.301 274.688 216.399 275.053C217.497 275.417 218.595 275.721 219.694 276.025C220.792 276.328 221.951 276.571 223.11 276.814C224.269 277.057 225.428 277.24 226.587 277.422C227.746 277.604 228.905 277.725 230.125 277.847C231.284 277.968 232.504 278.029 233.664 278.09C234.823 278.151 236.043 278.151 237.202 278.151C238.361 278.151 239.52 278.09 240.679 278.029C241.96 277.968 243.241 277.847 244.522 277.665C245.803 277.482 247.024 277.3 248.305 277.057C249.525 276.814 250.745 276.511 251.904 276.207C253.063 275.903 254.161 275.539 255.259 275.113C256.357 274.688 257.394 274.263 258.37 273.777C259.346 273.291 260.261 272.744 261.116 272.198C262.153 271.529 263.129 270.8 263.983 270.011C264.837 269.221 265.569 268.371 266.24 267.52C266.85 266.609 267.399 265.698 267.826 264.726C268.253 263.754 268.497 262.782 268.68 261.749C268.863 260.717 268.863 259.684 268.741 258.591C268.558 257.315 268.253 256.282 267.765 255.31Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.595 157.266V243.465L131.115 279.608C131.115 279.608 56.5672 234.535 59.9225 130.234L126.783 157.266H167.595Z",
    fill: "url(#paint0_linear_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4368 132.057L59.9224 130.234C56.5062 234.535 131.115 279.608 131.115 279.608L132.396 278.333C93.2309 249.175 63.3387 196.508 64.4368 132.057Z",
    fill: "url(#paint1_linear_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.594 157.267V243.465L204.135 279.609C204.135 279.609 253.305 246.442 249.889 190.798L208.467 157.327H167.594V157.267Z",
    fill: "url(#paint2_linear_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.655 188.065L249.827 190.799C253.305 246.442 204.074 279.609 204.074 279.609L202.793 278.334C242.812 248.568 247.814 207.2 246.655 188.065Z",
    fill: "url(#paint3_linear_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.41 156.902V243.101L203.952 279.245C203.952 279.245 253.121 246.077 249.705 190.434L208.283 156.902H167.41Z",
    fill: "url(#paint4_linear_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.534 187.64L249.706 190.373C253.184 246.016 203.953 279.184 203.953 279.184L202.672 277.908C242.63 248.203 247.632 206.835 246.534 187.64Z",
    fill: "url(#paint5_linear_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.548 183.023L256.72 182.111C256.72 182.111 267.335 184.845 270.812 192.317C273.496 198.087 266.664 204.527 261.662 202.522C256.598 200.517 254.707 196.022 254.707 196.022L254.463 197.602C254.158 198.756 252.572 199.059 251.901 198.087C251.047 196.812 250.193 194.746 249.888 191.284C249.278 183.751 253.548 183.023 253.548 183.023Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.839 135.033C218.289 148.823 239.335 164.373 256.721 182.111L249.889 191.284C228.72 181.2 204.746 168.99 179.551 155.869L195.839 135.033Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.791 198.027C253.791 198.027 253.852 198.148 253.974 198.391C253.913 198.452 253.791 198.513 253.73 198.573L253.791 198.027ZM270.812 192.317C267.334 184.845 256.72 182.111 256.72 182.111C239.333 164.373 218.287 148.762 195.837 135.033L193.336 138.192C215.42 151.192 238.235 167.411 255.438 184.055C255.438 184.055 266.114 186.485 269.775 193.896C270.629 195.658 270.629 197.541 269.958 199.181C271.361 197.237 271.91 194.746 270.812 192.317Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.548 183.023L256.72 182.111C256.72 182.111 267.335 184.845 270.812 192.317C273.496 198.087 266.664 204.527 261.662 202.522C256.598 200.517 254.707 196.022 254.707 196.022L254.463 197.602C254.158 198.756 252.572 199.059 251.901 198.087C251.047 196.812 250.193 194.746 249.888 191.284C249.278 183.751 253.548 183.023 253.548 183.023Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.839 135.033C218.289 148.823 239.335 164.373 256.721 182.111L249.889 191.284C228.72 181.2 204.746 168.99 179.551 155.869L195.839 135.033Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.791 198.027C253.791 198.027 253.852 198.148 253.974 198.391C253.913 198.452 253.791 198.513 253.73 198.573L253.791 198.027ZM270.812 192.317C267.334 184.845 256.72 182.111 256.72 182.111C239.333 164.373 218.287 148.762 195.837 135.033L193.336 138.192C215.42 151.192 238.235 167.411 255.438 184.055C255.438 184.055 266.114 186.485 269.775 193.896C270.629 195.658 270.629 197.541 269.958 199.181C271.361 197.237 271.91 194.746 270.812 192.317Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4615 128.655L59.7402 130.417C59.7402 130.417 49.6745 128.959 45.0991 122.094C41.6219 116.81 47.2343 109.459 52.5417 110.735C57.7881 112.011 60.4112 116.141 60.4112 116.141L60.2282 113.651C60.2282 111.95 61.9974 111.707 62.8514 112.618C63.8885 113.712 65.0476 116.749 65.9017 120.09C67.6098 127.258 63.4615 128.655 63.4615 128.655Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.503 171.664C100.794 164.253 74.8064 147.001 59.7383 130.356L66.2658 122.642C88.8374 131.51 111.226 139.347 136.116 140.987L130.503 171.664Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.357 166.925L130.503 171.664C100.794 164.253 74.8063 147.001 59.7382 130.356C59.7382 130.356 49.6724 128.898 45.0971 122.034C44.121 120.576 43.877 118.997 44.06 117.417C44.182 118.389 44.5481 119.361 45.2191 120.212C50.0385 126.955 61.0803 128.777 61.0803 128.777C76.5144 144.753 101.77 160.365 131.357 166.925ZM60.1652 113.59C60.2262 113.651 60.2872 113.712 60.2872 113.712L60.2262 113.104C60.2262 113.226 60.1652 113.347 60.1652 113.469V113.59Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4615 128.655L59.7402 130.417C59.7402 130.417 49.6745 128.959 45.0991 122.094C41.6219 116.81 47.2343 109.459 52.5417 110.735C57.7881 112.011 60.4112 116.141 60.4112 116.141L60.2282 113.651C60.2282 111.95 61.9974 111.707 62.8514 112.618C63.8885 113.712 65.0476 116.749 65.9017 120.09C67.6098 127.258 63.4615 128.655 63.4615 128.655Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.503 171.664C100.794 164.253 74.8064 147.001 59.7383 130.356L66.2658 122.642C88.8374 131.51 111.226 139.347 136.116 140.987L130.503 171.664Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M131.357 166.925L130.503 171.664C100.794 164.253 74.8063 147.001 59.7382 130.356C59.7382 130.356 49.6724 128.898 45.0971 122.034C44.121 120.576 43.877 118.997 44.06 117.417C44.182 118.389 44.5481 119.361 45.2191 120.212C50.0385 126.955 61.0803 128.777 61.0803 128.777C76.5144 144.753 101.77 160.365 131.357 166.925ZM60.1652 113.59C60.2262 113.651 60.2872 113.712 60.2872 113.712L60.2262 113.104C60.2262 113.226 60.1652 113.347 60.1652 113.469V113.59Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.826 294.309C113.24 288.478 120.377 282.646 131.053 279.548H144.657C142.156 292.001 127.576 301.477 118.974 298.561C116.961 297.893 115.375 296.314 114.826 294.309Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.766 279.608C139.105 290.846 125.746 299.047 117.693 296.314C116.595 295.949 115.68 295.281 114.887 294.43C115.436 296.374 117.022 297.954 118.974 298.622C127.637 301.598 142.217 292.061 144.657 279.608H142.766Z",
    fill: "#334E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.29 229.372C223.29 228.825 223.229 228.218 223.229 227.671C223.107 225.484 222.924 223.297 222.619 221.111C222.558 220.564 222.497 220.017 222.375 219.41C222.314 218.863 222.192 218.316 222.131 217.77C222.07 217.223 221.948 216.676 221.887 216.129C221.765 215.583 221.704 215.036 221.582 214.55C221.46 214.003 221.338 213.457 221.277 212.849C221.155 212.302 221.033 211.756 220.911 211.209C220.789 210.662 220.667 210.116 220.545 209.569C220.362 208.901 220.24 208.172 220.057 207.504C219.996 207.078 219.874 206.714 219.813 206.289C213.041 178.953 199.132 153.258 201.023 135.763H167.593H134.162C136.053 153.258 122.144 178.892 115.373 206.289C115.312 206.714 115.19 207.078 115.129 207.504C114.946 208.172 114.824 208.901 114.641 209.569C114.519 210.116 114.397 210.662 114.275 211.209C114.153 211.756 114.031 212.302 113.909 212.849C113.787 213.396 113.665 213.943 113.604 214.55C113.482 215.097 113.421 215.644 113.299 216.129C113.177 216.676 113.116 217.223 113.055 217.77C112.994 218.316 112.872 218.863 112.811 219.41C112.75 219.956 112.628 220.503 112.567 221.111C112.262 223.297 112.079 225.484 111.957 227.671C111.896 228.218 111.896 228.825 111.896 229.372C111.225 246.685 115.739 263.936 131.051 279.609H144.655C144.838 266.67 153.196 258.773 167.654 258.712C182.112 258.712 190.469 266.67 190.652 279.609H204.195C219.447 263.936 223.961 246.624 223.29 229.372Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M223.291 229.372C223.291 228.825 223.23 228.218 223.23 227.671C223.108 225.484 222.925 223.297 222.62 221.111C222.559 220.564 222.498 220.017 222.376 219.41C222.315 218.863 222.193 218.316 222.132 217.77C222.071 217.223 221.949 216.676 221.888 216.129C221.766 215.583 221.705 215.036 221.583 214.55C221.461 214.003 221.339 213.457 221.278 212.849C221.156 212.302 221.034 211.756 220.912 211.209C220.79 210.662 220.668 210.116 220.546 209.569C220.363 208.901 220.241 208.172 220.058 207.504C219.997 207.078 219.875 206.714 219.814 206.289C213.042 178.953 199.133 153.258 201.024 135.763H196.754C195.595 153.561 209.016 179.075 215.665 206.228C215.726 206.653 215.849 207.018 215.91 207.443C216.093 208.172 216.215 208.84 216.398 209.569C216.52 210.116 216.642 210.662 216.764 211.209C216.886 211.756 217.008 212.302 217.13 212.849C217.252 213.396 217.374 214.003 217.435 214.55C217.557 215.097 217.618 215.644 217.74 216.19C217.862 216.737 217.923 217.284 217.984 217.83C218.045 218.377 218.167 218.924 218.228 219.531C218.289 220.078 218.411 220.685 218.472 221.232C218.777 223.48 218.96 225.667 219.082 227.914C219.143 228.461 219.143 229.068 219.143 229.615C219.814 246.745 215.543 263.876 201.207 279.487H204.197C219.448 263.936 223.962 246.624 223.291 229.372Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.111 279.609H134.1C119.764 263.997 115.493 246.866 116.165 229.736C116.165 229.189 116.226 228.582 116.226 228.035C116.348 225.788 116.531 223.601 116.836 221.353C116.897 220.807 116.958 220.199 117.08 219.652C117.141 219.106 117.263 218.559 117.324 217.951C117.385 217.405 117.507 216.858 117.568 216.311C117.69 215.765 117.751 215.218 117.873 214.671C117.995 214.124 118.117 213.517 118.178 212.97C118.3 212.424 118.422 211.877 118.544 211.33C118.666 210.783 118.788 210.237 118.91 209.69C119.093 208.961 119.215 208.293 119.398 207.564C119.459 207.139 119.581 206.774 119.642 206.349C126.291 179.135 139.651 153.622 138.553 135.884H134.283C136.174 153.379 122.265 179.013 115.493 206.41C115.432 206.835 115.31 207.199 115.249 207.625C115.066 208.293 114.944 209.022 114.761 209.69C114.639 210.237 114.517 210.783 114.395 211.33C114.273 211.877 114.151 212.424 114.029 212.97C113.907 213.517 113.785 214.064 113.724 214.671C113.602 215.218 113.541 215.765 113.419 216.251C113.297 216.797 113.236 217.344 113.175 217.891C113.114 218.437 112.992 218.984 112.931 219.531C112.87 220.078 112.748 220.624 112.687 221.232C112.382 223.419 112.199 225.605 112.077 227.792C112.016 228.339 112.016 228.946 112.016 229.493C111.284 246.624 115.799 263.936 131.111 279.609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.36 294.309C221.946 288.478 214.809 282.646 204.133 279.548H190.59C193.091 292.001 207.671 301.477 216.273 298.561C218.225 297.893 219.811 296.314 220.36 294.309Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.481 279.608C196.141 290.846 209.501 299.047 217.554 296.314C218.652 295.949 219.567 295.281 220.36 294.43C219.811 296.374 218.225 297.954 216.273 298.622C207.61 301.598 193.03 292.061 190.59 279.608H192.481Z",
    fill: "#334E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.242 204.041C202.059 174.093 188.883 159.028 189.432 135.823H167.592H145.752C146.301 158.967 133.185 174.093 132.941 204.041C132.941 204.345 132.941 204.588 132.941 204.891C132.941 222.751 148.437 237.269 167.592 237.269C186.747 237.269 202.242 222.751 202.242 204.891C202.242 204.588 202.242 204.345 202.242 204.041Z",
    fill: "url(#paint6_radial_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.721 57.6436L223.78 52.3587L210.542 38.205L198.219 24.9624C208.651 3.45833 232.747 -3.28446 241.227 6.37413C253.062 19.799 244.399 46.8309 228.721 57.6436Z",
    fill: "url(#paint7_radial_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.779 52.3585L210.541 38.2047C211.517 38.5691 212.432 38.9944 213.347 39.4196C214.262 39.8448 215.299 40.3915 216.214 39.6626C216.702 39.2981 216.946 38.6299 216.885 37.9617C216.763 36.6253 215.726 35.7141 214.689 34.9244L218.532 34.4992C219.508 34.3777 219.996 33.1628 219.325 32.4338C218.532 31.6441 217.556 31.0367 216.458 30.6722C214.689 30.0647 212.798 30.0647 210.968 30.0647C212.615 29.518 214.323 28.9713 216.031 28.4246C216.519 28.2424 217.007 28.0601 217.251 27.6349C217.495 27.1489 217.19 26.4807 216.763 26.1162C216.275 25.7518 215.665 25.691 215.116 25.6303C213.103 25.448 211.029 25.5088 209.016 25.8733C216.885 13.4811 230.062 6.13086 236.041 10.869C245.74 21.0743 233.112 45.1904 223.779 52.3585Z",
    fill: "url(#paint8_linear_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.106 37.1726C237.08 46.0415 230.919 53.0273 216.217 38.752C208.042 30.7943 199.196 25.0842 198.403 24.659C198.342 24.7805 198.281 24.8412 198.281 24.902L210.604 38.1446L223.842 52.2984L228.783 57.5833C243.73 47.3172 252.27 22.2899 242.876 8.31836C246.719 16.9443 244.584 29.5187 241.106 37.1726Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.528 57.6432L111.47 52.3583L124.708 38.2045L137.031 24.9619C126.599 3.39714 102.441 -3.34565 94.0225 6.31294C82.1876 19.7985 90.8502 46.8304 106.528 57.6432Z",
    fill: "url(#paint9_radial_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.472 52.3581L124.71 38.2043C123.734 38.5687 122.819 38.994 121.903 39.4192C120.988 39.8444 119.951 40.3911 119.036 39.6622C118.548 39.2977 118.304 38.6295 118.365 37.9613C118.487 36.6249 119.524 35.7137 120.561 34.924L116.718 34.4988C115.742 34.3773 115.254 33.1624 115.925 32.4334C116.718 31.6437 117.694 31.0363 118.792 30.6718C120.561 30.0643 122.453 30.0643 124.283 30.0643C122.636 29.5176 120.927 28.9709 119.219 28.4242C118.731 28.242 118.243 28.0597 117.999 27.6345C117.755 27.1485 118.06 26.4803 118.487 26.1158C118.975 25.7514 119.585 25.6906 120.134 25.6299C122.147 25.4476 124.222 25.5084 126.235 25.8729C118.426 13.5415 105.249 6.13046 99.2098 10.8686C89.5711 21.0739 102.138 45.19 111.472 52.3581Z",
    fill: "url(#paint10_linear_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1446 37.1717C98.1709 46.0406 104.332 53.0263 119.034 38.7511C127.209 30.7934 136.055 25.0832 136.848 24.658C136.909 24.7795 136.97 24.8403 136.97 24.901L124.647 38.1436L111.409 52.2974L106.468 57.5823C91.5824 47.377 83.0418 22.3497 92.4975 8.31738C88.5322 16.9433 90.6674 29.5177 94.1446 37.1717Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.142 63.9605C217.193 41.0593 200.661 15.7891 168.207 15.7891C168.024 15.7891 167.841 15.7891 167.658 15.7891C167.475 15.7891 167.292 15.7891 167.109 15.7891C134.654 15.7891 118.183 41.0593 98.1735 63.9605C76.6999 89.5953 93.5371 114.015 100.919 121.001C118.366 137.524 143.744 146.757 167.719 146.818C191.693 146.757 217.01 137.463 234.518 121.001C241.778 114.076 258.615 89.656 237.142 63.9605Z",
    fill: "url(#paint11_radial_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.57 87.834C247.57 88.1985 247.631 88.6237 247.631 88.9882C247.57 88.6237 247.57 88.2592 247.57 87.834Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.266 85.5254C247.327 86.1936 247.449 86.8618 247.51 87.4693C247.449 86.8011 247.388 86.1328 247.266 85.5254Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.137 123.066C231.954 123.249 231.71 123.431 231.527 123.552C231.71 123.37 231.954 123.249 232.137 123.066Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.512 87.5912C247.512 87.5305 247.512 87.4697 247.512 87.4697C247.512 87.5912 247.512 87.7127 247.573 87.8949C247.512 87.7735 247.512 87.7127 247.512 87.5912Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.268 85.3436C247.268 85.2828 247.268 85.1613 247.207 85.1006C247.207 85.2221 247.268 85.4043 247.268 85.5258C247.268 85.4651 247.268 85.4043 247.268 85.3436Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.143 84.5537C247.143 84.4322 247.082 84.3715 247.082 84.25C247.143 84.4322 247.143 84.6752 247.204 84.8575C247.143 84.736 247.143 84.6752 247.143 84.5537Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.211 121.184C233.54 121.852 232.808 122.459 232.137 123.067C232.869 122.459 233.54 121.791 234.211 121.184Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.495 119.907L235.434 119.968C235.434 119.968 235.495 119.968 235.495 119.907Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.432 119.969C235.249 120.151 235.066 120.333 234.883 120.515C235.066 120.394 235.249 120.212 235.432 119.969Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.631 91.9043C247.631 92.2688 247.631 92.6332 247.57 92.937C247.57 92.6332 247.631 92.2688 247.631 91.9043Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.571 93.1797C247.571 93.6049 247.51 93.9694 247.449 94.3339C247.51 93.9694 247.51 93.6049 247.571 93.1797Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.386 117.782C237.63 117.478 237.874 117.235 238.057 116.932C237.752 117.296 237.447 117.661 237.203 118.025C237.264 117.964 237.325 117.904 237.386 117.782Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.895 118.389C236.407 118.935 235.98 119.482 235.492 119.907C235.98 119.421 236.407 118.935 236.895 118.389Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.335 115.23L239.273 115.292C239.273 115.292 239.273 115.292 239.335 115.23Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.097 106.786C244.097 106.786 244.097 106.847 244.035 106.847C244.097 106.847 244.097 106.847 244.097 106.786Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.395 121.001C216.948 137.524 191.57 146.758 167.595 146.818C143.62 146.758 118.303 137.464 100.795 121.001C95.3658 115.838 84.751 101.259 88.2282 83.6428C96.8299 67.9096 116.839 70.1572 130.443 81.7597C132.395 83.3998 134.226 84.9792 136.056 86.4371C136.239 86.5586 148.44 95.8527 154.723 89.8996C162.776 82.3064 153.076 37.2937 136.788 24.5978C140.387 22.2895 144.23 20.3456 148.379 18.8877C154.784 32.434 164.728 60.8023 165.155 85.3437C165.155 85.4044 165.155 85.4652 165.155 85.5867C165.155 93.4229 167.534 92.9369 167.534 92.9369C167.534 92.9369 169.913 93.4229 169.913 85.5867C169.913 85.5259 169.913 85.4044 169.913 85.3437C170.34 60.8631 180.284 32.434 186.689 18.8877C190.838 20.3456 194.681 22.2895 198.28 24.5978C182.053 37.2937 172.292 82.3064 180.345 89.8996C186.628 95.792 198.829 86.5586 199.012 86.4371C200.843 84.9184 202.673 83.3998 204.625 81.7597C218.229 70.1572 238.299 67.9096 246.84 83.6428C250.378 101.259 239.824 115.899 234.395 121.001Z",
    fill: "url(#paint12_radial_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.436 68.3955C251.6 90.5677 238.24 110.31 231.957 116.506C215.119 133.029 190.657 142.262 167.597 142.323C144.476 142.262 120.075 132.968 103.237 116.506C96.9538 110.371 83.5938 90.6285 94.7577 68.3955C78.5305 92.3901 93.8426 114.441 100.858 121.001C118.305 137.524 143.683 146.758 167.658 146.818C191.633 146.758 216.95 137.464 234.458 121.001C241.351 114.441 256.664 92.3901 240.436 68.3955Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.283 112.071C180.283 112.071 179.795 114.258 179.307 116.081C177.965 121.183 174.488 130.903 167.594 130.903C159.603 130.903 156.186 117.66 155.393 114.076C155.271 113.529 155.027 112.011 155.027 112.011",
    stroke: "#B28560",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.979 113.043C179.979 113.043 176.868 130.963 167.595 130.963C158.322 130.963 155.211 113.226 155.211 113.226L156.858 113.59C158.566 113.894 160.335 113.894 161.921 113.59C163.813 113.226 165.521 112.375 166.68 111.099C167.168 110.553 167.595 110.553 168.022 111.099C169.181 112.436 170.889 113.226 172.78 113.59C174.366 113.894 176.135 113.894 177.844 113.59L179.979 113.043Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.5 117.903L172.659 113.468C170.829 113.104 167.474 109.823 167.413 109.155C167.413 109.823 164.241 112.922 162.594 113.347L163.753 117.842C163.875 118.328 164.363 118.692 164.912 118.692H170.402C170.89 118.814 171.378 118.449 171.5 117.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.593 121.669C164.055 121.669 161.005 122.945 159.297 124.888C161.249 128.23 163.933 130.963 167.593 130.963C171.254 130.963 173.938 128.23 175.829 124.888C174.182 122.945 171.132 121.669 167.593 121.669Z",
    fill: "#F2A694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.873 105.268C186.202 105.086 185.531 105.511 185.348 106.118C184.738 108.487 182.176 110.492 178.698 111.282C174.855 112.193 171.073 111.403 169.243 109.338C168.999 109.034 168.877 108.67 168.877 108.184V107.09V103.749C168.877 103.081 168.328 102.534 167.656 102.534C166.985 102.534 166.436 103.081 166.436 103.749V107.09V108.184C166.436 108.67 166.314 109.034 166.07 109.338C164.24 111.403 160.458 112.193 156.615 111.282C153.137 110.492 150.575 108.487 149.965 106.118C149.782 105.45 149.111 105.086 148.44 105.268C147.769 105.45 147.403 106.118 147.586 106.786C148.44 110.127 151.612 112.679 156.066 113.772C157.347 114.076 158.567 114.197 159.787 114.197C163.02 114.197 165.887 113.165 167.717 111.282C169.548 113.165 172.415 114.197 175.648 114.197C176.868 114.197 178.088 114.076 179.369 113.772C183.823 112.739 186.995 110.127 187.849 106.786C187.91 106.118 187.544 105.45 186.873 105.268Z",
    fill: "#B28560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.466 94.0302C180.466 98.4039 172.413 103.81 167.655 103.81C162.53 103.81 154.844 98.3432 154.844 94.0302C154.844 89.7173 164.177 88.3809 167.655 88.3809C171.071 88.4416 180.466 89.7173 180.466 94.0302Z",
    fill: "url(#paint13_linear_197_176900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.594 92.5112C170.492 92.5112 172.84 92.0761 172.84 91.5393C172.84 91.0025 170.492 90.5674 167.594 90.5674C164.697 90.5674 162.348 91.0025 162.348 91.5393C162.348 92.0761 164.697 92.5112 167.594 92.5112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.887 74.5912C144.12 74.5912 149.173 69.5598 149.173 63.3532C149.173 57.1467 144.12 52.1152 137.887 52.1152C131.654 52.1152 126.602 57.1467 126.602 63.3532C126.602 69.5598 131.654 74.5912 137.887 74.5912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.035 71.0678C141.786 71.0678 145.637 67.2331 145.637 62.5027C145.637 57.7723 141.786 53.9375 137.035 53.9375C132.285 53.9375 128.434 57.7723 128.434 62.5027C128.434 67.2331 132.285 71.0678 137.035 71.0678Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.445 62.3648C143.226 61.9712 143.133 60.2202 142.236 58.4538C141.339 56.6874 139.978 55.5745 139.197 55.968C138.415 56.3616 138.508 58.1126 139.405 59.879C140.302 61.6454 141.663 62.7584 142.445 62.3648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.888 66.2687C143.562 66.2687 144.108 65.7248 144.108 65.0538C144.108 64.3828 143.562 63.8389 142.888 63.8389C142.214 63.8389 141.668 64.3828 141.668 65.0538C141.668 65.7248 142.214 66.2687 142.888 66.2687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.368 74.5912C203.601 74.5912 208.654 69.5598 208.654 63.3532C208.654 57.1467 203.601 52.1152 197.368 52.1152C191.135 52.1152 186.082 57.1467 186.082 63.3532C186.082 69.5598 191.135 74.5912 197.368 74.5912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.516 71.0678C201.266 71.0678 205.117 67.2331 205.117 62.5027C205.117 57.7723 201.266 53.9375 196.516 53.9375C191.765 53.9375 187.914 57.7723 187.914 62.5027C187.914 67.2331 191.765 71.0678 196.516 71.0678Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.925 62.3658C202.707 61.9722 202.614 60.2212 201.717 58.4548C200.82 56.6884 199.459 55.5754 198.677 55.969C197.895 56.3626 197.989 58.1136 198.886 59.88C199.783 61.6464 201.143 62.7593 201.925 62.3658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.369 66.2687C203.042 66.2687 203.589 65.7248 203.589 65.0538C203.589 64.3828 203.042 63.8389 202.369 63.8389C201.695 63.8389 201.148 64.3828 201.148 65.0538C201.148 65.7248 201.695 66.2687 202.369 66.2687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.05 91.6613C228.71 91.6613 233.298 89.7847 233.298 87.4698C233.298 85.1549 228.71 83.2783 223.05 83.2783C217.389 83.2783 212.801 85.1549 212.801 87.4698C212.801 89.7847 217.389 91.6613 223.05 91.6613Z",
    fill: "#F2857C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.143 91.6613C117.804 91.6613 122.392 89.7847 122.392 87.4698C122.392 85.1549 117.804 83.2783 112.143 83.2783C106.483 83.2783 101.895 85.1549 101.895 87.4698C101.895 89.7847 106.483 91.6613 112.143 91.6613Z",
    fill: "#F2857C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_176900",
    x1: 10.4982,
    y1: 208.678,
    x2: 106.576,
    y2: 204.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_176900",
    x1: 99.4888,
    y1: 243.395,
    x2: 87.3461,
    y2: 135.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3652,
    stopColor: "#605A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6066,
    stopColor: "#575154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8114,
    stopColor: "#494346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_176900",
    x1: 290.06,
    y1: 222.151,
    x2: 214.507,
    y2: 218.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_197_176900",
    x1: 213.109,
    y1: 275.197,
    x2: 249.876,
    y2: 198.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3652,
    stopColor: "#605A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6066,
    stopColor: "#575154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8114,
    stopColor: "#494346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_197_176900",
    x1: 289.891,
    y1: 221.748,
    x2: 214.338,
    y2: 218.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_197_176900",
    x1: 212.941,
    y1: 274.793,
    x2: 249.709,
    y2: 197.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3652,
    stopColor: "#605A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6066,
    stopColor: "#575154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8114,
    stopColor: "#494346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_197_176900",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.764 140.747) rotate(90) scale(89.047 40.8141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_197_176900",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(220.975 11.2732) scale(36.8709 36.7146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#615B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#5A5457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8427,
    stopColor: "#4F494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9501,
    stopColor: "#3E383B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_197_176900",
    x1: 203.942,
    y1: 29.6992,
    x2: 235.623,
    y2: 31.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_197_176900",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.288 11.2727) rotate(180) scale(36.8709 36.7146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#615B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#5A5457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8427,
    stopColor: "#4F494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9501,
    stopColor: "#3E383B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_197_176900",
    x1: 131.322,
    y1: 29.6988,
    x2: 99.6407,
    y2: 31.2896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_197_176900",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.587 87.9946) rotate(-90) scale(70.4704 88.003)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363052,
    stopColor: "#352F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6595,
    stopColor: "#565053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635D5F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_197_176900",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168.348 52.5917) scale(95.7913 95.3852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F3DFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7208,
    stopColor: "#EFDAC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8569,
    stopColor: "#E9D0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    stopColor: "#E1C3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_197_176900",
    x1: 167.618,
    y1: 101.315,
    x2: 167.618,
    y2: 87.7658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_176900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 316,
    fill: "white",
    transform: "translate(44 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugarGliderOk);
export default __webpack_public_path__ + "static/media/sugarGlider_ok.ff492e4676621e44509a540eb8dbf733.svg";
export { ForwardRef as ReactComponent };